const types = {
  //Get Request List
  GET_PO_START: "GET_PO_START",
  GET_PO_SUCCESS: "GET_PO_SUCCESS",
  GET_PO_ERROR: "GET_PO_ERROR",
  GET_PO_RESET: "GET_PO_RESET",

  //Create Request
  CREATE_PO_START: "CREATE_PO_START",
  CREATE_PO_SUCCESS: "CREATE_PO_SUCCESS",
  CREATE_PO_ERROR: "CREATE_PO_ERROR",
  CREATE_PO_RESET: "CREATE_PO_RESET",

  //Update Request
  UPDATE_PO_START: "UPDATE_PO_START",
  UPDATE_PO_SUCCESS: "UPDATE_PO_SUCCESS",
  UPDATE_PO_ERROR: "UPDATE_PO_ERROR",
  UPDATE_PO_RESET: "UPDATE_PO_RESET",

  //Delete Request
  DELETE_PO_START: "DELETE_PO_START",
  DELETE_PO_SUCCESS: "DELETE_PO_SUCCESS",
  DELETE_PO_ERROR: "DELETE_PO_ERROR",
  DELETE_PO_RESET: "DELETE_PO_RESET",

  //Single Request
  SINGLE_PO_START: "SINGLE_PO_START",
  SINGLE_PO_SUCCESS: "SINGLE_PO_SUCCESS",
  SINGLE_PO_ERROR: "SINGLE_PO_ERROR",
  SINGLE_PO_RESET: "SINGLE_PO_RESET",
};

export default types;

